import { Dispatch, SetStateAction } from "react";
import generateQuery from './functions/generateQuery';
import { DocumentNode } from "@apollo/client";
import { ArticleClass, CategoryClass, DateClass, DownloadClass, EventClass, FormClass, GroupClass, ImageClass, LocationClass, NewsClass, PageClass, PatstoreUser, PersonClass, WebpageContent } from "@types";

export type SiteContext = {
    data: {
        articles: ArticleClass[],
        categories: CategoryClass[],
        downloads: DownloadClass[],
        calendar: DateClass[],
        images: ImageClass[],
        news: NewsClass[],
        forms: FormClass[],
        locations: LocationClass[],
        website: PageClass[],
        images: ImageClass[],
        persons: PersonClass[],
        groups: GroupClass[]
    };
}

export type SubMenuItem = {
    text: string;
    link: string;
}

export type ModuleCategory = {
    id: string;
    moduleId: string;
    label: string;
    key: string;
    connected_class: string;
    position: number;
    is_multi: boolean;
  };
  
  export type ModuleSettings = {
    [key: string]: any;
    categories: { id: string; label: string; value: string; position: number }[];
  };

  export type ModuleName = "Webseite" | "Beiträge" | "News" | "Kalender" | "Kategorien" | "Personen" | "Bilder" | "Trainingsgruppe" | "Downloads" | "Formulare" | "Nutzer" | "Orte";
  
  export const ModuleTypeMapping: Record<string, any> = {
    Webseite: PageClass,
    Beiträge: ArticleClass,
    News: NewsClass,
    // Add other mappings as needed
};

  

  export type Module = {
    objectId: string;
    name: ModuleName;
    path: string;
    icon: string;
    fields: Field[];
    position: number;
    project: Project;
    connected_class: string;
    categories: ModuleCategory[];
    settings: ModuleSettings;
  };

  export type Variables = {
    params: {
        module: {
            _eq: string;
        };
    };
    limit?: number;
    skip?: number;
    order?: string;
  }

export type DataFields = {
    module_path: string;
    fields: string[];
    params?: object;
    limit?: number;
    skip?: number;
    order?: string
}[]

export type DataObject ={
    [key in ModuleName]?: any;
}

export type GenerateQuery = (T: {objectName: string, fields: string[]}) => DocumentNode;